import {Box} from '@mui/material';
import {Controller} from 'react-hook-form';

import FieldLabel from '../EmmaiFieldLabel/EmmaiFieldLabel';
import Switch from '../Switch/Switch';

// eslint-disable-next-line react/prop-types
const SwitchField = ({control, name, label}) => (
  <Box>
    <FieldLabel>{label}</FieldLabel>
    <Controller name={name} control={control} render={({field: {value, onChange}}) => <Switch checked={!!value} onChange={e => onChange(e.target.checked)} />} />
  </Box>
);

export default SwitchField;
